// Firebase Setup for MIS Library System (Realtime DB)

// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAHTsuBZa_FqwYgkmQEJh_8AYGA5T8L7zQ",
  authDomain: "mis--library.firebaseapp.com",
  databaseURL: "https://mis--library-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mis--library",
  storageBucket: "mis--library.firebasestorage.app",
  messagingSenderId: "1023755296610",
  appId: "1:1023755296610:web:8f8d53ac8c6fa3c23d963b",
  measurementId: "G-2B3937N3LT"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);